import React from "react";
import { Modal } from "react-bootstrap";
import ButtonComponent from "../Button/Button";
import "./commonPopup.css";
const CommonPopup = ({
  show,
  setShow,
  onSubmit,
  image,
  title,
  description,
  buttonText,
  handleClose = () => setShow(false),
  isClose = true,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="common-popup"
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-image">
          <img src={image} alt="" width={"160px"} />
        </div>
        <div className="modal-title">{title}</div>
        <div className="modal-description">{description}</div>
      </Modal.Body>
      <Modal.Footer>
        {isClose && (
          <ButtonComponent
            type="yellowOutlined"
            variant="rounded"
            buttonText={"Cancel"}
            onClick={handleClose}
          />
        )}
        <ButtonComponent
          variant="rounded"
          buttonText={buttonText}
          onClick={onSubmit}
          style={isClose ? {} : { width: "185px" }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default CommonPopup;
